<template>
  <div>
    <multiselect
      :allow-empty="true"
      :class="
        isValid === null
          ? ''
          : isValid
          ? 'multiselect__valid'
          : 'multiselect__invalid'
      "
      :clear-on-select="false"
      :close-on-select="true"
      :custom-label="createLabel"
      :hide-selected="false"
      :internal-search="false"
      :label="label"
      :loading="loading"
      :max-height="600"
      :options-limit="5000"
      :multiple="multiple"
      :options="options"
      :placeholder="placeholder || $lang.select_async.placeholder"
      :searchable="true"
      :selectLabel="$lang.multiselect.selectLabel"
      :selectedLabel="$lang.multiselect.selectedLabel"
      :show-labels="true"
      :track-by="id"
      :disabled="disabled"
      @input="updateValue"
      @search-change="delaySearch"
      @remove="removeItem"
      @open="open"
      deselect-label
      v-model="output"
    >
      <template slot="noOptions">
        <strong>{{ $lang.select_async.placeholder }}</strong>
      </template>
      <template slot="noResult">
        <strong>{{
          focused ? "در حال جستجو..." : $lang.multiselect.noResult
        }}</strong>
      </template>
      <template slot="singleLabel" slot-scope="{ option }">
        <span v-if="overrideLabel">
          <slot name="label"></slot>
        </span>
        <span v-else>{{ option[label] }}</span>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },
  props: {
    value: {
      type: [Object, Array],
      default: () => {},
    },
    label: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    isValid: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    asyncFind: {
      type: Function,
      default: null,
    },
    customLabel: {
      type: Function,
      default: (option) => {
        return option["label"];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    overrideLabel: {
      type: Boolean,
      default: false,
    },
    debounceTime: {
      type: Number,
      default: 800,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedCountries: [],
      output: this.value,
      isLoading: false,
      debounceGet: null,
      focused: false,
    };
  },
  methods: {
    updateValue() {
      this.$emit("input", this.output);
    },
    createLabel(option) {
      if (this.overrideLabel) {
        return this.customLabel(option);
      } else {
        return option[this.label];
      }
    },
    delaySearch(value) {
      this.focused = true;
      if (this.debounceGet) {
        clearTimeout(this.debounceGet);
        this.debounceGet = null;
      }
      this.debounceGet = setTimeout(() => {
        this.asyncFind(value);
        this.focused = false;
      }, this.debounceTime);
    },
    removeItem(item) {
      this.$emit("removeItem", item);
    },
    open(item) {
      this.$emit("open", item);
    },
  },
  watch: {
    value() {
      this.output = this.value;
    },
  },
};
</script>

<style></style>
